export const SUPPORT_EMAIL = ["support", "@", "wodota", ".", "net"].join("");

export const SUPPORT_EMAIL_HREF = `mailto:${SUPPORT_EMAIL}`;
